







































































































































































































































































































































































































































































































































































































































































































































































































































































































































































import { localISODate } from "@/utils/localDate";
import { Component, Vue, Watch } from "vue-property-decorator";
import FornasStore from "@/store/modules/FornasComplianceStore";
import Service from "@/services/FornasComplianceService";
import { userModule } from "@/store/modules/user";
import http from "@/axios/http-common";
import UnitRuangPicker from "@/components/common/UnitRuangPicker.vue";

@Component({ components: { UnitRuangPicker } })
export default class FornasCompliancePage extends Vue {
  fornasStore = FornasStore;

  activeTab = 0;

  // --- Tab 1: Evaluasi state ---
  showForm = false;
  isEdit = false;
  currentEval: any = null;
  saving = false;
  uploading = false;
  uploadFile: File | null = null;

  // --- Tarik dari Resep (picker) ---
  showResepPicker = false;
  loadingResep = false;
  resepError = "";
  resepCandidates: any[] = [];
  resepFilter: any = {
    date_from: localISODate(),
    date_to: localISODate(),
    unit: null,
    search: "",
  };
  resepHeaders = [
    { text: "Tanggal", value: "tanggal_resep", width: "100px" },
    { text: "No. Resep", value: "no_resep", width: "130px" },
    { text: "Pasien", value: "nama_pasien" },
    { text: "No. RM", value: "no_rekam_medis", width: "90px" },
    { text: "Dokter", value: "dokter_nama" },
    { text: "Ruangan", value: "unit_nama", width: "130px" },
    { text: "Item", value: "jumlah_item", width: "60px", align: "center" },
    { text: "Aksi", value: "actions", sortable: false, width: "110px", align: "center" },
  ];

  filterBulan: number = new Date().getMonth() + 1;
  filterTahun: number = new Date().getFullYear();
  filterDepo: string | null = null;
  filterStatusResep: string | null = null;
  filterTanggal: string | null = null;
  filterStatus: string | null = null;

  showDeleteDialog = false;
  deleteTarget: any = null;

  form: any = {
    tanggal_resep: localISODate(),
    no_resep: "",
    nama_pasien: "",
    no_rekam_medis: "",
    dokter_id: null,
    dokter_nama: "",
    depo_farmasi: "",
    unit_instalasi: "",
    nama_pencatat: "",
    nama_pencatat_id: null,
    tanggal_evaluasi: localISODate(),
    jenis_pasien: "rawat_jalan",
    cara_bayar: "bpjs",
    diagnosa_icd10_kode: "",
    diagnosa_icd10_uraian: "",
    alasan_lainnya_detail: "",
    rencana_tindak_lanjut: "",
  };

  formItems: any[] = [];
  selectedReasonIds: number[] = [];
  reasonDefinitions: any[] = [];

  // Dokter options
  dokterOptions: any[] = [];

  // Drug catalog for autocomplete
  drugCatalogItems: any[] = [];

  // --- Tab 2: Rekap state ---
  rekapBulan: number = new Date().getMonth() + 1;
  rekapTahun: number = new Date().getFullYear();
  rekapDepo: string | null = null;
  loadingRekap = false;
  monthlyReport: any = null;

  // --- Tab 3: Scorecard state ---
  scorecardBulan: number = new Date().getMonth() + 1;
  scorecardTahun: number = new Date().getFullYear();
  loadingScorecard = false;

  // --- Sign dialog ---
  showSignDialog = false;
  signTier = "pencatat";
  signPassword = "";
  signing = false;
  signTargetId: number | null = null;

  // --- Options ---
  bulanOptions = [
    { text: "Januari", value: 1 },
    { text: "Februari", value: 2 },
    { text: "Maret", value: 3 },
    { text: "April", value: 4 },
    { text: "Mei", value: 5 },
    { text: "Juni", value: 6 },
    { text: "Juli", value: 7 },
    { text: "Agustus", value: 8 },
    { text: "September", value: 9 },
    { text: "Oktober", value: 10 },
    { text: "November", value: 11 },
    { text: "Desember", value: 12 },
  ];

  depoOptions = [
    { text: "Depo Rawat Jalan", value: "depo_ralan" },
    { text: "Depo Rawat Inap", value: "depo_ranap" },
    { text: "Depo IGD", value: "depo_igd" },
    { text: "Depo OK", value: "depo_ok" },
  ];

  unitInstalasiOptions = [
    { text: "Rawat Jalan", value: "rawat_jalan" },
    { text: "Rawat Inap", value: "rawat_inap" },
    { text: "IGD", value: "igd" },
    { text: "OK / Bedah", value: "ok" },
    { text: "ICU / HCU", value: "icu" },
  ];

  jenisPasienOptions = [
    { text: "Rawat Jalan", value: "rawat_jalan" },
    { text: "Rawat Inap", value: "rawat_inap" },
    { text: "IGD", value: "igd" },
  ];

  caraBayarOptions = [
    { text: "BPJS", value: "bpjs" },
    { text: "Umum", value: "umum" },
    { text: "Asuransi", value: "asuransi" },
    { text: "Jamkesda", value: "jamkesda" },
  ];

  statusResepFilterOptions = [
    { text: "Sesuai FORNAS", value: "sesuai_fornas" },
    { text: "Tidak Sesuai", value: "tidak_sesuai_fornas" },
    { text: "Eksklusi", value: "eksklusi" },
    { text: "Draft", value: "draft" },
  ];

  statusFilterOptions = [
    { text: "Draft", value: "draft" },
    { text: "Submitted", value: "submitted" },
    { text: "Verified", value: "verified" },
    { text: "Approved", value: "approved" },
  ];

  signTierOptions = [
    { text: "Petugas Pencatat", value: "pencatat" },
    { text: "Ka. Instalasi Farmasi (Ka. IFRS)", value: "ka_ifrs" },
    { text: "Komite Mutu / Approver", value: "approver" },
  ];

  evalHeaders = [
    { text: "No", value: "no", width: "50px", align: "center", sortable: false },
    { text: "Tanggal", value: "tanggal_resep", width: "100px" },
    { text: "No. Resep", value: "no_resep", width: "130px" },
    { text: "Pasien", value: "nama_pasien" },
    { text: "Dokter", value: "dokter_nama" },
    { text: "Jml Item", value: "jumlah_item", width: "70px", align: "center" },
    { text: "Status Resep", value: "status_resep", width: "120px", align: "center" },
    { text: "Status", value: "status", width: "90px", align: "center" },
    { text: "Aksi", value: "actions", sortable: false, width: "140px", align: "center" },
  ];

  dailyRekapHeaders = [
    { text: "Tanggal", value: "tanggal", width: "100px" },
    { text: "Total Resep", value: "total_resep", width: "90px", align: "center" },
    { text: "Sesuai", value: "total_sesuai", width: "80px", align: "center" },
    { text: "Tidak Sesuai", value: "total_tidak_sesuai", width: "100px", align: "center" },
    { text: "Eksklusi", value: "total_eksklusi", width: "80px", align: "center" },
    { text: "Capaian", value: "capaian_persen", width: "100px", align: "center" },
  ];

  scorecardHeaders = [
    { text: "Rank", value: "ranking", width: "60px", align: "center" },
    { text: "Dokter", value: "dokter_nama" },
    { text: "Spesialisasi", value: "spesialisasi", width: "120px" },
    { text: "Total Resep", value: "total_resep", width: "90px", align: "center" },
    { text: "Sesuai", value: "total_sesuai", width: "80px", align: "center" },
    { text: "Tidak Sesuai", value: "total_tidak_sesuai", width: "100px", align: "center" },
    { text: "Capaian", value: "capaian_persen", width: "100px", align: "center" },
    { text: "Tren (3 bln)", value: "tren", width: "130px", sortable: false },
  ];

  // --- Computed ---

  get isLocked(): boolean {
    return (this.currentEval && this.currentEval.is_locked) || false;
  }

  get formStatusResep(): string {
    if (this.formItems.length === 0) return "draft";
    const hasNonFornas = this.formItems.some(
      (i: any) => i.status_fornas_item === "tidak_sesuai"
    );
    if (hasNonFornas) return "tidak_sesuai_fornas";
    const allExcluded = this.formItems.every(
      (i: any) => i.status_fornas_item === "eksklusi"
    );
    if (allExcluded) return "eksklusi";
    return "sesuai_fornas";
  }

  get hasAlasanLainnya(): boolean {
    const lainnya = this.reasonDefinitions.find(
      (r: any) => r.kode === "lainnya"
    );
    return lainnya ? this.selectedReasonIds.includes(lainnya.id) : false;
  }

  get signTierLabel(): string {
    const labels: any = {
      pencatat: "Petugas Pencatat",
      ka_ifrs: "Ka. Instalasi Farmasi (Ka. IFRS)",
      approver: "Komite Mutu / Approver",
    };
    return labels[this.signTier] || "";
  }

  // --- Lifecycle ---

  async mounted() {
    // Set pencatat dari user login
    this.form.nama_pencatat_id = userModule.user ? userModule.user.id : null;
    this.form.nama_pencatat = userModule.user ? userModule.user.nama : "";

    // Support direct navigation via query
    if (this.$route.query.tab === "rekap") {
      this.activeTab = 1;
    } else if (this.$route.query.tab === "scorecard") {
      this.activeTab = 2;
    }

    // Load initial data
    await Promise.all([
      this.loadEvaluations(),
      this.loadDokterList(),
      this.loadDrugCatalog(),
      this.loadReasonDefinitions(),
    ]);
  }

  // --- Tab Watchers ---

  @Watch("activeTab")
  onTabChange(val: number) {
    if (val === 1 && this.fornasStore.dailyRekap.length === 0) {
      this.loadRekapData();
    }
    if (val === 2 && this.fornasStore.scorecards.length === 0) {
      this.loadScorecardData();
    }
  }

  // --- Tab 1: Evaluasi Methods ---

  async loadEvaluations() {
    const params: any = {};
    if (this.filterBulan) params.bulan = this.filterBulan;
    if (this.filterTahun) params.tahun = this.filterTahun;
    if (this.filterDepo) params.depo_farmasi = this.filterDepo;
    if (this.filterStatusResep) params.status_resep = this.filterStatusResep;
    if (this.filterTanggal) params.tanggal = this.filterTanggal;
    if (this.filterStatus) params.status = this.filterStatus;
    await this.fornasStore.loadEvaluations(params);
  }

  async loadDokterList() {
    try {
      const res = await http.getData("/combo/dokter");
      this.dokterOptions = (res.data || []).map((d: any) => ({
        text: d.nama,
        value: d.user_id,
        spesialisasi: (d.idsp && isNaN(Number(d.idsp))) ? d.idsp : null,
      }));
    } catch {
      this.dokterOptions = [];
    }
  }

  async loadDrugCatalog() {
    try {
      await this.fornasStore.loadDrugCatalog({ per_page: 9999 });
      this.drugCatalogItems = this.fornasStore.drugCatalog.map((d: any) => ({
        text: `${d.nama_generik} — ${d.bentuk_sediaan || ''} (${d.kode_fornas || '-'})`,
        value: d.id,
        kode_fornas: d.kode_fornas,
        nama_generik: d.nama_generik,
        bentuk_sediaan: d.bentuk_sediaan,
        kekuatan_dosis: d.kekuatan_dosis,
        kfa_code: d.kfa_code,
      }));
    } catch {
      this.drugCatalogItems = [];
    }
  }

  async loadReasonDefinitions() {
    try {
      const res = await Service.getReasonDefinitions();
      this.reasonDefinitions = res.data.data || [];
    } catch {
      this.reasonDefinitions = [];
    }
  }

  tambahBaru() {
    this.isEdit = false;
    this.currentEval = null;
    this.resetForm();
    this.showForm = true;
  }

  async lihatEvaluasi(item: any) {
    this.isEdit = true;
    await this.fornasStore.loadEvaluation(item.id);
    this.currentEval = this.fornasStore.currentEvaluation;
    if (this.currentEval) {
      this.populateForm(this.currentEval);
    }
    this.showForm = true;
  }

  cetakPdf(item: any) {
    const url = Service.getPdfUrl(item.id);
    window.open(url, "_blank");
  }

  hapusEvaluasi(item: any) {
    this.deleteTarget = item;
    this.showDeleteDialog = true;
  }

  async confirmDelete() {
    if (!this.deleteTarget) return;
    try {
      await this.fornasStore.deleteEvaluation(this.deleteTarget.id);
      this.showDeleteDialog = false;
      this.deleteTarget = null;
      await this.loadEvaluations();
    } catch (e) {
      // Error handled by service
    }
  }

  closeForm() {
    this.showForm = false;
    this.currentEval = null;
    this.resetForm();
    this.loadEvaluations();
  }

  resetForm() {
    this.form = {
      tanggal_resep: localISODate(),
      no_resep: "",
      nama_pasien: "",
      no_rekam_medis: "",
      dokter_id: null,
      dokter_nama: "",
      depo_farmasi: "",
      unit_instalasi: "",
      nama_pencatat: userModule.user ? userModule.user.nama : "",
      nama_pencatat_id: userModule.user ? userModule.user.id : null,
      tanggal_evaluasi: localISODate(),
      jenis_pasien: "rawat_jalan",
      cara_bayar: "bpjs",
      diagnosa_icd10_kode: "",
      diagnosa_icd10_uraian: "",
      alasan_lainnya_detail: "",
      rencana_tindak_lanjut: "",
    };
    this.formItems = [];
    this.selectedReasonIds = [];
    this.uploadFile = null;
  }

  populateForm(data: any) {
    this.form.tanggal_resep = data.tanggal_resep;
    this.form.no_resep = data.no_resep;
    this.form.nama_pasien = data.nama_pasien;
    this.form.no_rekam_medis = data.no_rekam_medis;
    this.form.diagnosa_icd10_kode = data.diagnosa_icd10_kode || "";
    this.form.diagnosa_icd10_uraian = data.diagnosa_icd10_uraian || "";
    this.form.dokter_id = data.dokter_id;
    this.form.dokter_nama = data.dokter_nama;
    this.form.depo_farmasi = data.depo_farmasi;
    this.form.unit_instalasi = data.unit_instalasi;
    this.form.nama_pencatat = data.nama_pencatat;
    this.form.nama_pencatat_id = data.nama_pencatat_id;
    this.form.tanggal_evaluasi = data.tanggal_evaluasi;
    this.form.jenis_pasien = data.jenis_pasien;
    this.form.cara_bayar = data.cara_bayar;
    this.form.alasan_lainnya_detail = data.alasan_lainnya_detail || "";
    this.form.rencana_tindak_lanjut = data.rencana_tindak_lanjut || "";

    // Items
    this.formItems = (data.items || []).map((item: any) => ({
      id: item.id,
      fornas_drug_catalog_id: item.fornas_drug_catalog_id,
      nama_obat_sediaan: item.nama_obat_sediaan,
      kode_fornas: item.kode_fornas,
      dosis: item.dosis,
      bentuk_sediaan: item.bentuk_sediaan,
      jumlah: item.jumlah,
      signa: item.signa,
      status_fornas_item: item.status_fornas_item,
    }));

    // Reason IDs
    this.selectedReasonIds = (data.reasons || []).map((r: any) => r.id);
    this.reasonDefinitions = data.reason_definitions || this.fornasStore.reasonDefinitions || [];
  }

  async saveEvaluation() {
    this.saving = true;
    try {
      const items = this.formItems.map((item: any) => ({
        nama_obat_sediaan: item.nama_obat_sediaan,
        kfa_code: item.kfa_code || null,
        dosis: item.dosis || null,
        bentuk: item.bentuk || item.bentuk_sediaan || null,
        jumlah_diresepkan: item.jumlah || 1,
        signa: item.signa || null,
        alasan_item_detail: item.alasan_item_detail || null,
      }));
      const payload = {
        tanggal_resep: this.form.tanggal_resep,
        nama_petugas_id: this.form.nama_pencatat_id,
        nama_petugas: this.form.nama_pencatat,
        unit_instalasi: this.form.unit_instalasi,
        depo_farmasi: this.form.depo_farmasi,
        nama_dokter_dpjp_id: this.form.dokter_id,
        nama_dokter_dpjp: this.form.dokter_nama,
        pasien_id: this.form.no_rekam_medis || "0",
        nama_pasien: this.form.nama_pasien,
        no_rekam_medis: this.form.no_rekam_medis,
        no_resep: this.form.no_resep,
        cara_bayar: this.form.cara_bayar,
        diagnosa_icd10_kode: this.form.diagnosa_icd10_kode,
        diagnosa_icd10_uraian: this.form.diagnosa_icd10_uraian,
        alasan_lainnya_detail: this.form.alasan_lainnya_detail,
        rencana_tindak_lanjut: this.form.rencana_tindak_lanjut,
        items,
        reason_ids: this.selectedReasonIds,
      };

      if (this.isEdit && this.currentEval) {
        const result = await this.fornasStore.updateEvaluation({
          id: this.currentEval.id,
          data: payload,
        });
        this.currentEval = result;
        this.populateForm(result);
      } else {
        const result = await this.fornasStore.createEvaluation(payload);
        this.currentEval = result;
        this.isEdit = true;
        this.populateForm(result);
      }
    } catch (e) {
      // Error handled by service
    }
    this.saving = false;
  }

  onDokterChange(val: number) {
    const item = this.dokterOptions.find((d: any) => d.value === val);
    if (item) {
      this.form.dokter_nama = item.text;
    }
  }

  // --- Items ---

  addItemRow() {
    this.formItems.push({
      id: null,
      fornas_drug_catalog_id: null,
      nama_obat_sediaan: "",
      kfa_code: "",
      kode_fornas: "",
      dosis: "",
      bentuk: "",
      bentuk_sediaan: "",
      jumlah: 1,
      signa: "",
      status_fornas_item: "draft",
      alasan_item_detail: "",
    });
  }

  removeItemRow(idx: number) {
    this.formItems.splice(idx, 1);
  }

  onDrugSelect(item: any, val: any) {
    // val bisa berupa: number (catalog ID dari dropdown) atau string (free text manual)
    if (typeof val === "number") {
      const drug = this.drugCatalogItems.find((d: any) => d.value === val);
      if (drug) {
        item.nama_obat_sediaan = `${drug.nama_generik} — ${drug.bentuk_sediaan || ""}`;
        item.kfa_code = drug.kfa_code || "";
        item.kode_fornas = drug.kode_fornas || "";
        item.bentuk = drug.bentuk_sediaan || "";
        item.dosis = drug.kekuatan_dosis || "";
        item.status_fornas_item = "sesuai";
      }
    } else if (typeof val === "string" && val.trim()) {
      // Free text: obat non-FORNAS (ketik manual)
      item.nama_obat_sediaan = val.trim();
      item.kfa_code = "";
      item.kode_fornas = "";
      item.fornas_drug_catalog_id = null;
      item.status_fornas_item = "tidak_sesuai";
    }
  }

  // --- Tarik dari Resep ---

  openResepPicker() {
    this.resepError = "";
    this.showResepPicker = true;
    this.loadResepCandidates();
  }

  async loadResepCandidates() {
    this.loadingResep = true;
    this.resepError = "";
    try {
      const res = await Service.getResepCandidates(this.resepFilter);
      const body = res.data || {};
      this.resepCandidates = body.data || [];
      if (body.message) this.resepError = body.message;
    } catch (e) {
      this.resepCandidates = [];
    }
    this.loadingResep = false;
  }

  pickResepCandidate(cand: any) {
    // Prefill form baru dari resep — petugas tinggal verifikasi kesesuaian.
    this.isEdit = false;
    this.currentEval = null;
    this.resetForm();

    this.form.tanggal_resep = cand.tanggal_resep || this.form.tanggal_resep;
    this.form.no_resep = cand.no_resep || "";
    this.form.nama_pasien = cand.nama_pasien || "";
    this.form.no_rekam_medis = cand.no_rekam_medis || "";
    this.form.dokter_id = cand.dokter_id || null;
    // Resolusi nama dokter dari daftar combo (mirror onDokterChange) bila API tak membawanya.
    const dokOpt = this.dokterOptions.find((d: any) => d.value === cand.dokter_id);
    this.form.dokter_nama = cand.dokter_nama || (dokOpt ? dokOpt.text : "");
    if (cand.depo_farmasi) this.form.depo_farmasi = cand.depo_farmasi;
    if (cand.unit_instalasi) this.form.unit_instalasi = cand.unit_instalasi;
    this.form.diagnosa_icd10_uraian = cand.diagnosa_icd10_uraian || "";

    this.formItems = (cand.items || []).map((it: any) => ({
      id: null,
      // Obat resep = free-text (bukan dari katalog) — tampilkan namanya di combobox.
      fornas_drug_catalog_id: it.nama_obat_sediaan,
      nama_obat_sediaan: it.nama_obat_sediaan,
      kfa_code: it.kfa_code || "",
      kode_fornas: it.kode_fornas || "",
      dosis: it.dosis || "",
      bentuk: it.bentuk || "",
      bentuk_sediaan: it.bentuk || "",
      jumlah: it.jumlah || 1,
      signa: it.signa || "",
      status_fornas_item: it.status_fornas_item || "draft",
      alasan_item_detail: "",
    }));

    this.showResepPicker = false;
    this.showForm = true;
  }

  // --- Upload Document ---

  async doUploadDocument() {
    if (!this.currentEval || !this.uploadFile) return;
    this.uploading = true;
    try {
      const formData = new FormData();
      formData.append("document", this.uploadFile);
      await Service.uploadDocument(this.currentEval.id, formData);
      this.uploadFile = null;
    } catch (e) {
      // Error handled by service
    }
    this.uploading = false;
  }

  // --- Sign ---

  openSignDialog(item: any) {
    this.signTargetId = item.id;
    this.signTier = item.next_sign_tier || "pencatat";
    this.signPassword = "";
    this.showSignDialog = true;
  }

  async confirmSign() {
    if (!this.signTargetId || !this.signPassword) return;
    this.signing = true;
    try {
      if (this.signTier === "pencatat") {
        await this.fornasStore.signPencatat({
          id: this.signTargetId,
          password: this.signPassword,
        });
      } else if (this.signTier === "ka_ifrs") {
        await this.fornasStore.signKaIfrs({
          id: this.signTargetId,
          password: this.signPassword,
        });
      } else if (this.signTier === "approver") {
        await this.fornasStore.signApprover({
          id: this.signTargetId,
          password: this.signPassword,
        });
      }
      this.showSignDialog = false;
      this.signPassword = "";
      await this.loadEvaluations();
    } catch (e) {
      // Error handled by service
    }
    this.signing = false;
  }

  // --- Tab 2: Rekap Methods ---

  async loadRekapData() {
    this.loadingRekap = true;
    const params: any = {
      bulan: this.rekapBulan,
      tahun: this.rekapTahun,
    };
    if (this.rekapDepo) params.depo_farmasi = this.rekapDepo;

    try {
      const [, monthlyRes] = await Promise.all([
        this.fornasStore.loadDailyBreakdown(params),
        Service.getMonthlyReport(params),
      ]);
      this.monthlyReport = monthlyRes.data.data || null;

      // Also load trend
      await this.fornasStore.loadTrend({
        bulan: this.rekapBulan,
        tahun: this.rekapTahun,
      });
    } catch (e) {
      // Error handled by service
    }
    this.loadingRekap = false;
  }

  // --- Tab 3: Scorecard Methods ---

  async loadScorecardData() {
    this.loadingScorecard = true;
    try {
      await this.fornasStore.loadScorecard({
        bulan: this.scorecardBulan,
        tahun: this.scorecardTahun,
      });
    } catch (e) {
      // Error handled by service
    }
    this.loadingScorecard = false;
  }

  // --- Helpers ---

  formatDate(val: string): string {
    if (!val) return "-";
    const d = new Date(val);
    return d.toLocaleDateString("id-ID", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    });
  }

  statusResepColor(status: string): string {
    const map: any = {
      sesuai_fornas: "green",
      tidak_sesuai_fornas: "red",
      eksklusi: "grey",
      draft: "blue",
    };
    return map[status] || "grey";
  }

  statusResepLabel(status: string): string {
    const map: any = {
      sesuai_fornas: "Sesuai FORNAS",
      tidak_sesuai_fornas: "Tidak Sesuai",
      eksklusi: "Eksklusi",
      draft: "Draft",
    };
    return map[status] || status || "-";
  }

  statusColor(status: string): string {
    const map: any = {
      draft: "grey",
      submitted: "blue",
      verified: "orange",
      approved: "green",
    };
    return map[status] || "grey";
  }

  itemStatusColor(status: string): string {
    const map: any = {
      sesuai: "green",
      tidak_sesuai: "red",
      eksklusi: "grey",
      draft: "blue lighten-2",
    };
    return map[status] || "grey";
  }

  itemStatusLabel(status: string): string {
    const map: any = {
      sesuai: "Sesuai",
      tidak_sesuai: "Tidak Sesuai",
      eksklusi: "Eksklusi",
      draft: "Draft",
    };
    return map[status] || status || "-";
  }

  bulanShort(b: number): string {
    const names = [
      "Jan", "Feb", "Mar", "Apr", "Mei", "Jun",
      "Jul", "Agu", "Sep", "Okt", "Nov", "Des",
    ];
    return names[b - 1] || "";
  }
}
